import styled from "styled-components"
import "../../App.css"
import Photo0601 from "../../img/06_01.jpg"
import Photo0602 from "../../img/06_02.jpg"
import Photo0603 from "../../img/06_03.jpg"
import Photo0604 from "../../img/06_04.jpg"
import Photo0605 from "../../img/06_05.jpg"
import Photo0606 from "../../img/06_06.jpg"
import Photo0607 from "../../img/06_07.jpg"
import Photo0608 from "../../img/06_08.jpg"
import Photo0609 from "../../img/06_09.jpg"
import Photo0610 from "../../img/06_10.jpg"
import Photo0611 from "../../img/06_11.jpg"

const ContentBase06 = styled.div`
  background: #111;
  width: 100%;
  height: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
`

function SubMenuContent06(Photo01) {
  // const opts = {
  //   // height: "100",
  //   maxWidth: "100%",
  //   playerVars: {
  //     // https://developers.google.com/youtube/player_parameters
  //     autoPlay: 1,
  //   },
  // }
  return (
    <ContentBase06>
      <div className="typobase">
        인터랙션 테스트를 거쳐서 제작되지 않은 서비스는 장기적인 사용에 있어서
        디자이너가 찾아내지 못한 오점을 반드시 달고 나오기 마련입니다 퍼블리싱
        전 Prototype으로 실제앱에 가까운 UI를 완성하고 PC와 다른 환경에서 편집과
        그래픽을 확인합니다 <br />
        Prototype은 키보드, 마우스, 터치 모두를 지원하므로 활용성에 따라 PC에서
        Mobile, TV, 옥외 스크린까지 많은 디지털 매체의 인터랙션 테스트가
        가능합니다 <br />
        *실무 프로젝트가 아닌 기술 역량을 드러내기 위한 프로젝트입니다.
      </div>
      <img src={Photo0601} className="photobase" alt="Photo0601"></img>
      <div className="video-wrap">
        <iframe
          autoPlay="1"
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/OVE5ukLJRzQ"
          frameBorder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        ></iframe>
      </div>
      <img src={Photo0602} className="photobase" alt="Photo0602"></img>
      <div className="typobase typocenter ">
        모바일 디바이스는 각기 다른 여러 해상도로 구동 되고 있어서, 하나하나
        절대 죄표로 제작하기 힘듭니다.
        <br />
        GUI와 콘텐츠 좌표를 절대좌표 px가 아닌 가변(%) 좌표로 모든 디바이스에
        호환될 수 있는 앱을 디자인합니다.
        <br />
        디바이스의 ppi는 다양하지만 ppi는 비슷한 수치를 가지므로 크기가 아닌
        여백을 변형으로 GUI를 제작합니다.
      </div>
      <img src={Photo0603} className="photobase" alt="Photo0603"></img>
      <div className="typotitle">Produce48 Ballot APP Services</div>
      <div className="video-wrap">
        <iframe
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/dC6Yh0xfLJc"
          frameBorder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="typotitle">Coupang E-Commerce Responsive Web</div>
      <div className="video-wrap">
        <iframe
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/L1ZaIEQvfuA"
          frameBorder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="typotitle">NETFLIX Streaming Services</div>
      <div className="video-wrap">
        <iframe
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/VStX0_CD4NE"
          frameBorder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="typotitle">​​​​​​​JYP Artist Preview APP</div>

      <div className="video-wrap">
        <iframe
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/6mGh9mHybLs"
          frameBorder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="typotitle">G.O.G Digilog Music Cassette</div>
      <div className="video-wrap">
        <iframe
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/GR-2mZWxP7E"
          frameBorder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="typotitle">
        ​​​​​​​Toss Fintech Services (Improved Functionality)
      </div>
      <div className="video-wrap">
        <iframe
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/Hrjq07JYK-E"
          frameBorder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="typotitle">
        ​​​​​​​The Turbulence Of The LAMBS Game APP
      </div>
      <div className="video-wrap">
        <iframe
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/DeM25Iq7BYI"
          frameBorder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="typotitle">War for the Planet of the Apes PR APP</div>
      <div className="video-wrap">
        <iframe
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/Mt99JP8rgsw"
          // frameborder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          // allowfullscreen
        ></iframe>
      </div>
      <div className="typotitle">Unicef Magazine APP</div>
      <div className="video-wrap">
        <iframe
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/5vAkaMI_cU8"
          // frameborder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          // allowfullscreen
        ></iframe>
      </div>
      <div className="typotitle">Nike Running Shoes Commerce</div>
      <div className="video-wrap ">
        <iframe
          rel="0"
          title="기술시연"
          width="1246"
          height="701"
          src="https://www.youtube.com/embed/t02okr1SAv4"
          // frameborder="0"
          allow="accelerometer; autoPlay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          // allowfullscreen
        ></iframe>
      </div>
      <img src={Photo0604} className="photobase" alt="Photo0603"></img>
      <img src={Photo0605} className="photobase" alt="Photo0603"></img>
      <img src={Photo0606} className="photobase" alt="Photo0603"></img>
      <img src={Photo0607} className="photobase" alt="Photo0603"></img>
      <img src={Photo0608} className="photobase" alt="Photo0603"></img>
      <img src={Photo0609} className="photobase" alt="Photo0603"></img>
      <img src={Photo0610} className="photobase" alt="Photo0603"></img>
      <img src={Photo0611} className="photobase" alt="Photo0603"></img>
    </ContentBase06>
  )
}

export default SubMenuContent06
